import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { needPlayChatNotification, setSoundNotificationState } from 'store/slices/windowStateSlice';
import { notificationAudioService } from './notificationAudioService';

export function useNotificationSound() {
  const dispatch = useAppDispatch();
  const { soundNotificationState } = useAppSelector(s => s.windowState);

  const enableSound = React.useCallback(async () => {
    const ok = await notificationAudioService.enableSound();

    dispatch(setSoundNotificationState({
      open: false,
      enabled: ok,
      denied: !ok
    }));
  }, []);

  const disableSound = React.useCallback(() => {
    localStorage.setItem('alreadyAllowSound', 'false');
    localStorage.setItem('alreadyDeniedSound', 'true');
    dispatch(setSoundNotificationState({
      open: false,
      enabled: false,
      denied: true
    }));
  }, []);

  const playSound = React.useCallback(() => {
    if (!soundNotificationState?.enabled) return;

    notificationAudioService.play();
    dispatch(needPlayChatNotification(false));
  }, [soundNotificationState?.enabled]);

  return { enableSound, disableSound, playSound };
};
